export default __webpack_public_path__ + "static/media/fastingbreak@2x.f3837244.jpg";